"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var EmailExclusivesProductCards_1 = require("./EmailExclusivesProductCards");
var SubscribeSave = function (_a) {
    var shopBundleProducts = _a.shopBundleProducts, shopSubProducts = _a.shopSubProducts;
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("p", { class: "subscribe-and-save-shop__header" },
            (0, preact_1.h)("span", { id: "product-shop-section", class: "proxima-nova extrabold" },
                "Best-Selling ",
                (0, preact_1.h)("br", { class: "hide-on-desktop" }),
                "Subscriptions")),
        (0, preact_1.h)(EmailExclusivesProductCards_1.default, { isDesktop: false, products: shopSubProducts }),
        (0, preact_1.h)("a", { href: "/collections/shop-all", class: "subscribe-and-save-shop__button" },
            "Shop All Products",
            ' '),
        (0, preact_1.h)("p", { class: "subscribe-and-save-shop__header" },
            (0, preact_1.h)("span", { class: "proxima-nova extrabold" }, "Save More With Bundles")),
        (0, preact_1.h)(EmailExclusivesProductCards_1.default, { isDesktop: false, products: shopBundleProducts }),
        (0, preact_1.h)("a", { href: "/collections/shop-bundles", class: "subscribe-and-save-shop__button" }, "Explore More Bundles")));
};
exports.default = SubscribeSave;
